import { defaultService as e } from "./DefaultService.js";
import { cidService as r } from "./CidService.js";
import { playersService as o } from "./PlayersService.js";
import { schemaJsonService as i } from "./SchemaJsonService.js";
const p = {
  default: e,
  cid: r,
  players: o,
  schemaJson: i
};
export {
  p as services
};
